import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Analytics, CannabisShowcaseAnalytics } from "./Analytics";

const CannabisShowCaseGridItem = ({ handleOpenModal, dataItem, restUrl }) => {
    const {
        name,
        image,
        // small_image,
        // thumbnail,
        featured_type,
        featured_type_varchar,
        sku
    } = dataItem;

    const gridItem = useRef(null);

    const [hover, setHover] = useState({
        isHovered: false,
    });

    const handleHoverIn = () => {
        gridItem.current.parentElement.classList.add("cannabisdirectory--hovered");

        setHover(prevState => ({
            ...prevState,
            isHovered: true,
            // isHovered: !prevState.isHovered,
        }));
    };

    const handleHoverOut = () => {
        gridItem.current.parentElement.classList.remove("cannabisdirectory--hovered");

        setHover(prevState => ({
            ...prevState,
            isHovered: false,
            // isHovered: !prevState.isHovered,
        }));
    };

    const typeClass =
        featured_type === "16322" || featured_type_varchar === "16322" || featured_type === "16323" || featured_type_varchar === "16323"
            ? "cannabisdirectory__item--premium"
            : "";

    const hoverClass = hover.isHovered ? "hovered" : "";

    useEffect(() => {
        // Push view event to Google Tag Manager
        Analytics.view(CannabisShowcaseAnalytics.makeMosaicEventProperties(dataItem));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // const getRandomInteger = (min, max) => {
    //     min = Math.ceil(min);
    //     max = Math.floor(max);
    //     return Math.floor(Math.random() * (max - min + 1)) + min;
    // }

    // const typeClass =
    //     getRandomInteger(1, 5) === 1
    //         ? "directory__item--gold"
    //         : getRandomInteger(1, 5) === 2
    //             ? "directory__item--silver"
    //             : getRandomInteger(1, 5) === 3
    //                 ? "directory__item--bronze"
    //                 : getRandomInteger(1, 5) === 4
    //                     ? "directory__item--nickel"
    //                     : "";

    return (
        <div
            ref={gridItem}
            onMouseEnter={handleHoverIn}
            onMouseLeave={handleHoverOut}
            onClick={() => handleOpenModal(sku)}
            className={`cannabisdirectory__item ${typeClass} ${hoverClass}`}
        >
            {/* {image || small_image || thumbnail ? ( */}
            {image ? (
                // <picture>
                //     <source
                //         media="(min-width: 992px)"
                //         // srcSet="https://googlechrome.github.io/samples/picture-element/images/kitten-large.png"
                //         srcSet={`${restUrl}/pub/media/catalog/product${image}`}
                //     />
                //     <source
                //         media="(min-width: 768px)"
                //         // srcSet="https://googlechrome.github.io/samples/picture-element/images/kitten-medium.png"
                //         srcSet={`${restUrl}/pub/media/catalog/product${small_image}`}
                //     />
                // </picture>
                <img
                    // src="https://googlechrome.github.io/samples/picture-element/images/kitten-small.png"
                    src={`${restUrl}/pub/media/catalog/product${image}`}
                    alt={name}
                    loading="lazy"
                />
            ) : (
                <img
                    // src="https://googlechrome.github.io/samples/picture-element/images/kitten-small.png"
                    src={`/images/image-not-found.png`}
                    alt={name}
                    loading="lazy"
                />
                // <picture>
                // </picture>
            )}
            <span>{name}</span>
        </div>
    );
};

CannabisShowCaseGridItem.defaultProps = {
    handleOpenModal: () => {},
    dataItem: {},
    restUrl: ""
};

CannabisShowCaseGridItem.propTypes = {
    handleOpenModal: PropTypes.func,
    dataItem: PropTypes.object,
    restUrl: PropTypes.string
};

export default CannabisShowCaseGridItem;
